import { FC, useEffect, useMemo, useState } from 'react';
import { useRequest } from 'umi';
import { get, isEmpty } from 'lodash';
import { Button, Dropdown, Empty, Input, MenuProps, message, Result, Tag } from 'antd';
import { DeleteOutlined, PlusCircleOutlined, PlusSquareOutlined } from '@ant-design/icons';
import styles from './index.less';
import { getQuestionById, searchQuestion } from '@/services/ConsoleRequest';
import { TQuestionObj } from '@/types/console/question';
import { EQuestionTypeEnum } from '@/enum/question';
import cx from 'classnames';
import { useDebounceFn } from 'ahooks';

type TFixQuestionSelectProps = {
  onChange?: (ids: string[]) => void;
  value?: string[];
  isEdit?: boolean;
  initValue?: string[];
};

const FixQuestionSelect: FC<TFixQuestionSelectProps> = (props) => {
  const { onChange, value, isEdit, initValue } = props;
  const [isDoSearch, setIsDoSearch] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [visible, setVisible] = useState(false);
  const [selectQuestionArray, setSelectQuestionArray] = useState<TQuestionObj[]>([]);
  const [questionArray, setQuestionArray] = useState<TQuestionObj[]>([]);
  const calcTypeStr = (type: EQuestionTypeEnum) => {
    switch (type) {
      case EQuestionTypeEnum.JUDGE:
        return '判断题';
      case EQuestionTypeEnum.MULTIPLE_CHOICE:
        return '多选题';
      case EQuestionTypeEnum.SINGLE_CHOICE:
        return '单选题';
      case EQuestionTypeEnum.SUBJECTIVE:
        return '主观题';
    }
  };
  const items: MenuProps['items'] = useMemo(() => {
    return questionArray
      .filter((item) => item.enable === 1)
      .map((item) => {
        return {
          key: item.id,
          label: (
            <div
              className={styles.dropdown_item}
              onClick={(e) => {
                e.stopPropagation();
                console.log('选择题目', item, selectQuestionArray);
                if (
                  !selectQuestionArray.find(
                    (selectQuestionArrayItem) => selectQuestionArrayItem.id === item.id,
                  )
                ) {
                  console.log('添加题目');
                  setVisible(false);
                  setSearchText('');
                  setSelectQuestionArray((prevState) => {
                    prevState.push(item);
                    onChange?.(prevState.map((item) => item.id));
                    return [...prevState];
                  });
                } else {
                  message.info('该题已选择过');
                }
              }}
            >
              <div className={styles.dropdown_item_name_wrapper}>
                <Tag>{calcTypeStr(item.type)}</Tag>
                <div className={cx('truncate', styles.dropdown_item_name)}>{item.title}</div>
              </div>
              <PlusCircleOutlined className={styles.dropdown_item_icon} />
            </div>
          ),
        };
      });
  }, [questionArray, selectQuestionArray]);
  const { run: doSearchQuestion, loading } = useRequest(
    (key) => {
      setIsDoSearch(false);
      return searchQuestion(key);
    },
    {
      manual: true,
      onSuccess: (res) => {
        console.log('data是');
        console.log(res);
        if (Array.isArray(res.records)) {
          setQuestionArray(res.records);
        }
        setIsDoSearch(true);
      },
    },
  );
  useEffect(() => {
    if (Array.isArray(initValue)) {
      console.log('要执行了');
      const promises = [];
      for (const id of initValue) {
        promises.push(getQuestionById(id));
      }
      Promise.allSettled(promises).then((results) => {
        const successArray = results
          .filter((item) => item.status === 'fulfilled' && get(item, 'value.data.enable') === 1)
          .map((item) => (item as any).value.data);
        onChange?.(successArray.map((item) => item.id));
        setSelectQuestionArray(successArray);
      });
    }
  }, [initValue]);
  const renderSearchText = () => {
    if (loading) {
      return '搜索中...';
    }
    if (!searchText && !loading) {
      return '请先输入';
    }
    if (questionArray.length === 0 && isDoSearch) {
      return '搜索结果为空';
    }
  };
  const { run: debounceSearch } = useDebounceFn(
    async (value) => {
      await doSearchQuestion(value);
    },
    {
      wait: 500,
    },
  );

  return (
    <div className={styles.fix_question}>
      {selectQuestionArray.map((item) => {
        return (
          <div key={item.id} className={styles.fix_question_item}>
            <div className={styles.fix_question_item_name_wrapper}>
              <Tag>{calcTypeStr(item.type)}</Tag>
              <div className={cx('truncate', styles.fix_question_item_name)}>{item.title}</div>
            </div>
            <DeleteOutlined
              className={styles.fix_question_item_icon}
              onClick={() => {
                const idx = selectQuestionArray.findIndex(
                  (selectItem) => selectItem.id === item.id,
                );
                if (idx > -1) {
                  console.log('找到了 要删除');
                  setSelectQuestionArray((prevState) => {
                    prevState.splice(idx, 1);
                    onChange?.(prevState.map((item) => item.id));
                    return [...prevState];
                  });
                }
              }}
            />
          </div>
        );
      })}
      <Dropdown
        open={visible}
        onOpenChange={(open) => {
          setVisible(open);
        }}
        getPopupContainer={(triggerNode) => {
          return triggerNode.parentNode as any;
        }}
        overlayStyle={{ width: '100%' }}
        overlayClassName={styles.fix_question_dropdown}
        trigger={['click']}
        menu={{ items }}
        dropdownRender={(menu) => (
          <div>
            <div className={styles.fix_question_dropdown_input_area}>
              <Input.Search
                loading={loading}
                value={searchText}
                onChange={async (e) => {
                  const text = e.target.value;
                  setSearchText(text);
                  debounceSearch(text);
                }}
                onSearch={async (value) => {
                  console.log(value);
                  await doSearchQuestion(value);
                }}
                placeholder="请输入题目ID、题目标题搜索题目"
              />
            </div>
            <div>
              {isEmpty(questionArray) ? (
                <Result subTitle={renderSearchText()} icon={<Empty />} />
              ) : (
                menu
              )}
            </div>
          </div>
        )}
      >
        <Button className={styles.btn} type="link" icon={<PlusSquareOutlined />}>
          点击添加
        </Button>
      </Dropdown>
    </div>
  );
};
export default FixQuestionSelect;
